export default "__VITE_ASSET__BpKm7fxD__"